import React, { Component } from "react";
import Header from "../components/Header";
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';

import {
    GridColumn as Column,
    GridDetailRow
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-material/dist/all.css";

import { Dialog } from "@progress/kendo-react-dialogs";
import { EditCell, DeleteCell } from "../components/utils/GridHelpers";

import OrgGroupSetDataPage from "./OrgGroupSetDataPage";
import OrgGroupDeletePage from "./OrgGroupDeletePage";

import { getExportFileName, isEmpty } from '../helpers';
import isPage from "../hoc/isPage";

import { AppContext } from "../context/AppContext";

import GridContainer, { GridContainerToolbar, GridContainerToolbarOption } from '../components/GridContainer';
import localize from "../hoc/localize";

class DetailsComponent extends GridDetailRow {
    render() {
        const dataItem = this.props.dataItem;

        if (dataItem.reportGroupOrgs) {
            return (
                <section className="report-group-orgs">
                    <ul>
                        {dataItem.reportGroupOrgs.map((item, index) => (
                            <li key={index}>
                                {item.orgName} {item.storeNumber ? `(${item.storeNumber})` : ''}
                            </li>
                        ))}
                    </ul>
                </section>
            );
        } else {
            return (
                <section className="report-group-orgs">
                    {this.props.returnLocalizedString("m0236")}
                </section>
            );
        }
    }
}

class OrgGroupPage extends Component {
    _export;
    _grid;
    //constructor(props) {
    //    super(props);
    //}

    state = {
        selectedReportGroupID: null,
        showEditModal: false,
        showDeleteModal: false
    };
    componentDidMount() {


        this.getData();
    }
    showCreateModal = () => {
        this.setState({
            showEditModal: true
        });
    };
    showEditModal = reportGroupID => {
        this.setState({
            showEditModal: true,
            selectedReportGroupID: reportGroupID
        });
    };
    showDeleteModal = reportGroupID => {
        this.setState({
            showDeleteModal: true,
            selectedReportGroupID: reportGroupID
        });
    };
    handleCloseModal = () => {
        this.setState({
            showEditModal: false,
            showDeleteModal: false,
            selectedReportGroupID: null
        });
    };
    handleRefreshListing = () => {
        this.getData(true);

    };

    // simply ensure that this.context.state.reportGroups has the most up-to-date set of report groups.
    // forceDataRetrieval is a flag that forces this function to do an API call to get the latest set of report groups.
    getData = (forceDataRetrieval = false) => {

        // if we don't have a set of report groups yet, OR someone forces us to do a data retrieval, then
        // do an API call
        if (isEmpty(this.context.state.reportGroups) || forceDataRetrieval) {

            this.props
                .getData("/api/portal/reportGroup/GetList?includeOrgsList=1")
                .then(response => {
                    this.context.setState({
                        reportGroups: response.data
                    })
                });
        }


    };
    expandChange = e => {
        e.dataItem.expanded = !e.dataItem.expanded;
        this.forceUpdate();
    };


    render() {
        const tabs = (<Tabs>
            <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
            <Tab label={this.props.returnLocalizedString("m0237")} ></Tab>
        </Tabs>);

            //!DBTRANS! @m0004@ Home !DEVNOTE! 
            //!DBTRANS! @m0008@ Report Group !DEVNOTE! Column name
            //!DBTRANS! @m0236@ There are no organizations under this reporting group. !DEVNOTE!
            //!DBTRANS! @m0237@ Report Group Management !DEVNOTE!
            //!DBTRANS! @m0238@ Create new group !DEVNOTE!
            //!DBTRANS! @m0239@ Please Confirm !DEVNOTE!

        return (
            <div>
                <Header title={this.props.returnLocalizedString("m0237")} tabs={tabs} />

                <section className="page-content-padding-top-70 grid-row pad-it">
                    <section className="grid-container">

                        {<GridContainer
                            data={this.context.state.reportGroups}

                            excelFilename={getExportFileName("Report-Groups")}

                            detail={localize(DetailsComponent)}
                            onExpandChange={this.expandChange}

                        >
                            <GridContainerToolbar>
                                <GridContainerToolbarOption type="add" tooltip="m0238" primary={true} handleClick={this.showCreateModal} />
                            </GridContainerToolbar>
                            <Column
                                field="reportGroupName"
                                title={this.props.returnLocalizedString("m0008")}
                            />
                            <Column
                                width="40px"
                                excludeFromExport
                                cell={props => (
                                    <EditCell
                                        dataItemKey="reportGroupID"
                                        handleEdit={this.showEditModal}
                                        {...props}
                                    />
                                )}
                            />
                            <Column
                                width="40px"
                                excludeFromExport
                                cell={props => (
                                    <DeleteCell
                                        dataItemKey="reportGroupID"
                                        handleDelete={this.showDeleteModal}
                                        {...props}
                                    />
                                )}
                            />
                        </GridContainer>
                        }

                    </section>
                </section>

                {this.state.showEditModal && (
                    <Dialog
                        width={"60%"}
                        minWidth={320}
                        height={"90%"}
                        onClose={this.handleCloseModal}
                    >
                        <OrgGroupSetDataPage
                            reportGroupID={this.state.selectedReportGroupID}
                            handleCloseModal={this.handleCloseModal}
                            handleRefreshListing={this.handleRefreshListing}
                        />
                    </Dialog>
                )}

                {this.state.showDeleteModal && (
                    <Dialog
                        title={this.props.returnLocalizedString("m0239")}
                        onClose={this.handleCloseModal}
                    >
                        <OrgGroupDeletePage
                            reportGroupID={this.state.selectedReportGroupID}
                            handleCloseModal={this.handleCloseModal}
                            handleRefreshListing={this.handleRefreshListing}
                        />
                    </Dialog>
                )}
            </div>
        );
    }
}

export default isPage(OrgGroupPage);

OrgGroupPage.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/containers/OrgGroupPage.js